import WorkCard from "../components/WorkCard";
import { Breadcrumb } from "flowbite-react";
import { HiHome } from "react-icons/hi";
import { TbTruckDelivery } from "react-icons/tb";
import { useTranslation } from "../i18n/LanguageContext";
import DocumentMeta from "react-document-meta";
import { buildPageMeta } from "../seo";
function WorksPage() {
    const { t } = useTranslation();
    const meta = buildPageMeta({
        title: `${t("works.title")} | Maurizio Brioschi`,
        description: "Portfolio lavori: esempi concreti di progetti web, architetture software e sviluppo applicativo.",
        keywords: "portfolio sviluppo web, lavori software, case study",
        path: "/works"
    });
    return(
        <>
            <DocumentMeta {...meta} />
            <Breadcrumb aria-label="Solid background breadcrumb example" className="bg-gray-50 px-5 py-3 dark:bg-gray-800">
                <Breadcrumb.Item href="/" icon={HiHome}>{t("nav.home")}</Breadcrumb.Item>
                <Breadcrumb.Item href="/works">{t("nav.works")}</Breadcrumb.Item>
            </Breadcrumb>
            <div>
                <h1 className="font-impact text-3xl mb-5 mt-5"><TbTruckDelivery/>{t("works.title")}</h1>
            </div>
            <WorkCard />
        </>

    );
}

export default WorksPage;
